import { type JSX, useCallback } from "react";

import { Link as RouterLink } from "react-router-dom";
import { Link, Typography } from "@mui/material";

import { WidgetCardHeader } from "../../../Pages/Customer/Dashboards/WidgetsGrid/Header/WidgetCardHeader";
import { jsUcfirst } from "../../../utils/common";
import mixpanel from "../../../utils/mixpanel";
import { HEADING_VARIANT } from "./cloudCardStyle";

type Props = {
  action?: JSX.Element;
  name: string;
  hasAccessToReport: boolean;
  description: string;
  hasFilter: boolean;
  reportUrl: string;
};

export const CardReportHeader = ({ action, hasAccessToReport, name, description, hasFilter, reportUrl }: Props) => {
  const redirectToReport = useCallback(() => {
    if (name === "[GKE Lens] Unallocated Resources by Cluster") {
      mixpanel.track("dashboards.gke-lens.cost-allocation-clusters");
    }
  }, [name]);

  const title = hasAccessToReport ? (
    <Link
      component={RouterLink}
      to={reportUrl}
      variant={hasFilter ? "h4" : HEADING_VARIANT}
      color="inherit"
      underline="hover"
    >
      {name}
    </Link>
  ) : (
    <Typography variant={HEADING_VARIANT}>{name}</Typography>
  );

  return (
    <WidgetCardHeader onClick={redirectToReport} title={title} subheader={jsUcfirst(description)} action={action} />
  );
};
